import { getStoreId } from "$/hooks/use-store-information"
import bikeForSaleQueries from "$/lib/queries/bike-for-sale-queries"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

const searchSchema = z.object({
  view: z.enum(["status", "list"]).optional(),
})

export const Route = createFileRoute("/(app)/_auth/bikes-for-sale/")({
  validateSearch: searchSchema,
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) queryClient.prefetchQuery(bikeForSaleQueries.list(storeId))
  },
})
